import { Images as IconImages } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Image,
  Row,
  Alert,
  Modal,
  Carousel,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { AlertOctagon } from "lucide-react";

import Loader from "../../components/Loader";

import reportService from "../../services/reports.service";

const Images = () => {
  const [reportImages, setReportImages] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const [showImageCarousel, setShowImageCarousel] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);

  const { reportId } = useParams();

  useEffect(() => {
    if (reportId) {
      getReportImages();
    }
  }, [reportId]);

  const getReportImages = async () => {
    setErrorMessage();
    const result = await reportService.getReportImagesPublic(reportId);
    if (result.success) {
      setReportImages(result.reportImages);
    } else {
      setErrorMessage(result.message);
    }
  };

  return (
    <>
      <Helmet title="Report Images" />
      <Container fluid className="p-0">
        <h1 className="mb-3">Report Images</h1>
        <Card>
          <Card.Header className="d-flex justify-content-start">
            <IconImages className="me-2" size={48} />
            <div>
              <Card.Title>Images for Report: {reportId}</Card.Title>
              <Card.Subtitle>
                {`All the report images created by Product Quality
                Inspection Specialists at Returns Worldwide for report: ${reportId}.`}
              </Card.Subtitle>
            </div>
          </Card.Header>
          <Card.Body>
            {reportImages ? (
              <Row>
                {reportImages.map((image, index) => {
                  return (
                    <Col key={image.imageId}>
                      <Image
                        src={`${image.imageSrc}`}
                        thumbnail
                        fluid
                        onClick={() => {
                          setShowImageCarousel(true);
                          setCarouselIndex(index);
                        }}
                        className="cursor-pointer"
                      />
                    </Col>
                  );
                })}
              </Row>
            ) : errorMessage ? (
              <Alert variant="danger" className="flex-fill alert-blink">
                <div className="alert-icon">
                  <AlertOctagon
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message font-weight-bold">
                  {errorMessage}
                </div>
              </Alert>
            ) : (
              <Loader />
            )}
          </Card.Body>
        </Card>
        <Modal
          show={showImageCarousel}
          onHide={() => setShowImageCarousel(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Damage Report Images</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Carousel
              indicators={true}
              controls={true}
              interval={null}
              activeIndex={carouselIndex}
              onSelect={(selectedIndex) => setCarouselIndex(selectedIndex)}
            >
              {reportImages?.map((image) => {
                return (
                  <Carousel.Item key={image.imageId}>
                    <Image src={`${image.imageSrc}`} fluid />
                    <Carousel.Caption>
                      <h3 className="text-white">{image.imageId}</h3>
                    </Carousel.Caption>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default Images;
